import { MatDialogRef } from '@angular/material/dialog';
import { WorkingHoursModel } from './models';
import { ConfirmationDialogAfterClosedModel } from '../../../../../ui-kit';

export class WorkingHoursListLoad {
  public static readonly type = '[WorkingHours] List Load';

  constructor(public payload: { compartmentId: number; dockId?: number }) {}
}

export class WorkingHoursItemLoad {
  public static readonly type = '[WorkingHours] Item Load';

  constructor(
    public payload: {
      compartmentId: number;
      dockId?: number;
      workingHoursId: number;
    },
  ) {}
}

export class WorkingHoursItemCreate {
  public static readonly type = '[WorkingHours] Item Create';

  constructor(
    public payload: {
      hubId: number;
      compartmentId: number;
      dockId?: number;
      data: WorkingHoursModel;
    },
  ) {}
}

export class WorkingHoursItemUpdate {
  public static readonly type = '[WorkingHours] Item Update';

  constructor(
    public payload: {
      compartmentId: number;
      dockId?: number;
      data: WorkingHoursModel;
    },
  ) {}
}

export class WorkingHoursItemDelete {
  public static readonly type = '[WorkingHours] Item Delete';

  constructor(
    public payload: {
      hubId: number;
      compartmentId: number;
      dockId?: number;
      dialog: MatDialogRef<ConfirmationDialogAfterClosedModel>;
      workingHoursIds: number[];
    },
  ) {}
}

export class WorkingHoursItemInitialState {
  public static readonly type = '[WorkingHours] Item Set initial state';
}

export class WorkingHoursInitialState {
  public static readonly type = '[WorkingHours] Set initial state';
}
